import { render, staticRenderFns } from "./HoboData.vue?vue&type=template&id=3cc54535&"
import script from "./HoboData.vue?vue&type=script&lang=js&"
export * from "./HoboData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports